export const TRAILER_LENGTHS = [
	{ checked: true, label: '53 Foot', value: '53' },
	{ checked: false, label: '48 Foot', value: '48' },
	{ checked: false, label: '45 Foot', value: '45' },
];
